import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { operatorItems } from 'components/powerFlowShared/components/modals/filters/util/helper';
import { getVariableName } from './utils/variable/getVariableName';
function getMatchText(node) {
    if (node.isMatching === false) {
        return 'No match';
    }
    const operator = Object.values(operatorItems).find(({ id }) => id.toUpperCase() === node.matching_rule.toUpperCase());
    return (_jsxs(_Fragment, { children: [getVariableName(node.variable_id), " ", operator === null || operator === void 0 ? void 0 : operator.name, ' ', _jsx("strong", { children: node.value })] }));
}
export function RoutedThroughFilter({ node }) {
    return (_jsxs(_Fragment, { children: ["Filter ", _jsx("strong", { children: node.description }), " \u00B7 ", getMatchText(node)] }));
}
